module.exports = __webpack_public_path__ + "static/media/icon_orden.696315ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden.svg
// module id = 630
// module chunks = 0